import { useState } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Mail, X, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';
import { apiClient } from '@/App';

export default function VerificationBanner({ user, onClose }) {
  const [sending, setSending] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Debug logging
  console.log('[VerificationBanner] Rendering - user:', user);
  console.log('[VerificationBanner] email_verified:', user?.email_verified);
  
  // Early return if no user
  if (!user) {
    console.log('[VerificationBanner] No user, returning null');
    return null;
  }
  
  // Check if verified
  if (user.email_verified === true) {
    console.log('[VerificationBanner] Email already verified, returning null');
    return null;
  }
  
  // Check if dismissed
  if (dismissed) {
    console.log('[VerificationBanner] Banner dismissed, returning null');
    return null;
  }
  
  console.log('[VerificationBanner] Rendering banner!');

  const handleResendEmail = async () => {
    setSending(true);
    try {
      await apiClient.post('/auth/send-verification-email');
      toast.success('Verification email sent! Please check your inbox.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send verification email');
    } finally {
      setSending(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    if (onClose) onClose();
  };

  return (
    <Alert className="border-amber-200 bg-amber-50 mb-4 relative">
      <AlertCircle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="ml-2 text-amber-800 flex items-center justify-between">
        <div className="flex-1">
          <span className="font-semibold">Email Verification Required</span>
          <p className="text-sm mt-1">
            Please verify your email ({user.email}) to unlock premium features like Ask and Case Review.
          </p>
        </div>
        <div className="flex items-center gap-2 ml-4">
          <Button
            onClick={handleResendEmail}
            disabled={sending}
            size="sm"
            className="bg-amber-600 hover:bg-amber-700 text-white"
          >
            <Mail className="w-4 h-4 mr-2" />
            {sending ? 'Sending...' : 'Resend Email'}
          </Button>
          <button
            onClick={handleDismiss}
            className="text-amber-600 hover:text-amber-800 p-1"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
